<template>
  <div class="account-watch padding-30">
    <div class="box">
      <p>账号：{{accountdata.username}}</p>
      <p>姓名：{{accountdata.name}}</p>
      <p>项目：{{accountdata.projectName}}</p>
      <p>FTP账号：{{accountdata.ftpUser}}</p>
      <p>启用：{{accountdata.enable?"开启":"停用"}}</p>
    </div>
    <el-button @click="$router.go(-1)" type="primary">返回</el-button>
  </div>
</template>

<script>
import { getInfo } from "@/api/user";
export default {
  data() {
    return {
      id: null,
      accountdata: {}
    };
  },
  created() {
    this.id = this.$route.params.id * 1;
    this.fetchData(this.id);
  },
  methods: {
    fetchData(id) {
      getInfo(id).then(res => {
        this.accountdata = res.data.account;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.account-watch {
  padding: 0 30px;
  .box {
    margin-bottom: 30px;
    p {
      margin-bottom: 22px;
    }
  }
}
</style>